import type { ChatAttachment } from './attachments'

/** Under the 15-minute lifetime of the presigned links Squad hands out. */
const REUSE_FOR_MS = 10 * 60 * 1000

const seenUrls = new Map<string, { url: string; seenAt: number }>()

/** Every `/messages/` poll re-presigns each file, so a fresh `url` would make
 * the browser download the same image again; keep the one that loaded. */
export const rememberAttachmentUrl = (id: string, url: string) => {
  if (seenUrls.get(id)?.url === url) return

  seenUrls.set(id, { url, seenAt: Date.now() })
}

export const stableAttachmentUrl = ({ id, url }: ChatAttachment) => {
  const seen = seenUrls.get(id)

  if (seen && Date.now() - seen.seenAt < REUSE_FOR_MS) return seen.url

  return url ?? null
}
